// Horizon が hidden のまま残してしまった画像を強制表示
document.addEventListener('DOMContentLoaded', function(){    
    document.querySelectorAll('.product-media img, .product__media img, .pplpr img').forEach(img => { img.style.visibility = 'visible'; });
});